__turbopack_context__.v({
  "answerQuestionSectionSection": "AnswerQuestionSection-module-scss-module__TgUKRW__answerQuestionSectionSection",
  "content": "AnswerQuestionSection-module-scss-module__TgUKRW__content",
  "moreAnswers": "AnswerQuestionSection-module-scss-module__TgUKRW__moreAnswers",
  "questions": "AnswerQuestionSection-module-scss-module__TgUKRW__questions",
  "title": "AnswerQuestionSection-module-scss-module__TgUKRW__title",
});
